import {arrays} from "@atttomyx/shared-utils";

const IOS_NO_BANNER_ADS = "noBannerAds";
const ANDROID_NO_BANNER_ADS = "no_banner_ads";

export const isNoBannerAds = (id) => IOS_NO_BANNER_ADS === id || ANDROID_NO_BANNER_ADS === id;

export const containsNoBannerAds = (ids) => arrays.contains(ids, IOS_NO_BANNER_ADS)
    || arrays.contains(ids, ANDROID_NO_BANNER_ADS);
